import React from "react";
import {TextField as TextFieldMaterial} from '@material-ui/core';

const TextField = ({
                       id,
                       name,
                       className,
                       valueChanged,
                       label,
                       keyPressed,
                       type,
                       legacyMode,
                       required,
                       fullWidth,
                       variant,
                       inputProps,
                       disabled,
                       value,
                       placeholder,
                       inputLabelProps,
                       autoFocus,
                       autoComplete,
                       size
                   }) => {
    const updateValue = (event) => {
        const newValue = event.currentTarget.value;
        valueChanged(newValue);
    };
    return (
        <TextFieldMaterial fullWidth={fullWidth}
                           disabled={disabled}
                           variant={variant}
                           inputProps={inputProps}
                           required={required}
                           className={className}
                           id={id}
                           name={name}
                           label={label}
                           onChange={legacyMode ? valueChanged : updateValue}
                           onKeyDown={keyPressed}
                           value={value}
                           type={type}
                           placeholder={placeholder}
                           InputLabelProps={inputLabelProps}
                           autoFocus={autoFocus}
                           autoComplete={autoComplete}
                           size={size}
        />
    );
};

TextField.defaultProps = {
    legacyMode: false,
    required: false,
    fullWidth: true,
    variant: "standard",
    disabled: false,
    placeholder: '',
    autoFocus: false,
    autoComplete: 'on',
    size: 'medium'
}

export default TextField;